module.exports = __webpack_public_path__ + "static/media/Election Hockey2.8457a619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/multiplayer_card_images/Election Hockey2.jpg
// module id = 670
// module chunks = 0